import { schema } from "normalizr";

export const userSchema = new schema.Entity("users", {}, { idAttribute: "UserId" });
export const usersSchema = new schema.Array(userSchema);

export const availableUser = new schema.Entity(
    "availableUsers",
    {},
    {
        idAttribute: "UserId",
        processStrategy: u => ({
            ...u,
            IsEnabled: !u.IsDisabledUser,
        }),
    }
);
export const availableUsersSchema = new schema.Array(availableUser);
